<nav class="flex justify-between mb-7"> <!--mb-1-->
    <ol class="inline-flex items-center space-x-1 md:space-x-3">
        <li class="inline-flex items-center">
            <a [routerLink]="['/']" class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-green-700">
                <mat-icon class="mr-2" fontIcon="home"></mat-icon>
                {{"lib.DASHBOARD" | translate}}
            </a>
        </li>
        <li *ngFor="let item of items; let i = index">
            <div class="flex items-center">
                <mat-icon class="text-gray-400" fontIcon="chevron_right"></mat-icon>
                <a [routerLink]="item.link" class="ml-1 text-sm font-medium md:ml-2" [class]="items.length === i+1 ? 'text-gray-500':'text-gray-700 hover:text-green-700'">{{item.label}}</a>
            </div>
        </li>
    </ol>
    <div>
        <ng-content></ng-content>
    </div>
</nav>